import moment from "moment";
import XLSX from 'xlsx';

const utils = {
  formattingStringWithTime: (string, sec = false) => {
    if (sec) return moment(string).format('DD-MM-YYYY HH:mm:ss')
    else return moment(string).format('DD-MM-YYYY HH:mm')
  },
  fixedNum: (e) => (e % 1) === 0 ? e : e.toFixed(1),
  random(num1OrArr, num2) {
    // if first is array
    if (Array.isArray(num1OrArr)) { //array element
      if (num1OrArr.length === 0) {
        console.log('Пустой массив');
        return
      }
      return num1OrArr[Math.floor(Math.random() * num1OrArr.length)]
    } else if (typeof num1OrArr === 'number' && typeof num2 === 'number') { //min to max
      if (num1OrArr > num2) [num1OrArr, num2] = [num2, num1OrArr]
      return num1OrArr + Math.random() * (num2 - num1OrArr)
    } else if (typeof num1OrArr === 'number' && !num2) { //only 1 number
      return Math.random() * num1OrArr
    } else if (!num1OrArr && !num2) { //no arguments
      return Math.random()
    }
  },
  transcript(ruStr) {
    let ru = {
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
      'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'i',
      'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
      'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
      'ф': 'f', 'х': 'kh', 'ц': 'tc', 'ч': 'ch', 'ш': 'sh',
      'щ': 'shch', 'ъ': 'y', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'iu', 'я': 'ia'
    };
    let n_str = [];

    ruStr = ruStr.replace(/[ь]+/g, '')

    for (let i = 0; i < ruStr.length; ++i) {
      n_str.push(
        ru[ruStr[i]]
        || ru[ruStr[i].toLowerCase()] == undefined && ruStr[i]
        || ru[ruStr[i].toLowerCase()].replace(/^(.)/, function (match) { return match.toUpperCase() })
      )
    }

    return n_str.join('')
  },

  generateCsv(csvString, name) {
    let blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
    let url = URL.createObjectURL(blob);
    let a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', name || 'file.csv')
    a.click()
  },
  /**
   *
   * @param {array} data - данные таблицы
   * @param {object} options - объект опций
   * @param {string} options.fileName - имя файла
   * @param {string} options.sheetName - имя вкладки
   * @param {object} options.headers - заголовки формата {name: 'имя'}
   *
   * @example
   * let data = [
   *  {name: 'Вася', age: '18'},
   *  {name: 'петя', age: '19'},
   * ]
   * let headers = {
   *  name: 'имя',
   *  age: 'возраст'
   * }
   * let fileName = 'таблица 21.xlsx'
   * let sheetName = 'таблица 21'
   * generateXlsx(data, {headers, fileName, sheetName})
   *
   */
  generateXlsx(data, options = {}) {
    let workbook = XLSX.utils.book_new()
    let worksheet = XLSX.utils.json_to_sheet(data)
    let sheetName = options.sheetName || 'first'

    if (options.headers) {
      let headers = Object.values(options.headers)

      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
    }

    //ширина колонок
    let tWidths = {}
    let widths = []
    let keys = Object.keys(data[0])
    data.forEach(row => {
      keys.forEach(k => {
        tWidths[k] = Math.max(tWidths[k] || 10, row[k].length + 1)
      })
    })


    if (options.headers) {
      keys.forEach(k => {
        let letterLength = options.headers[k]?.length || 0
        tWidths[k] = Math.max(letterLength + 1, tWidths[k])
      })
    }

    keys.forEach(k => {
      widths.push({ wch: tWidths[k] })
    })

    worksheet['!cols'] = widths


    workbook.SheetNames.push(sheetName);
    workbook.Sheets[sheetName] = worksheet;

    XLSX.writeFile(workbook, options.fileName || 'file.xlsx');
  },

  downloadXlsx(response) {
    let url = window.URL.createObjectURL(response.data)
    let filename = response.headers['content-disposition'].match(/(?<=filename=).+xlsx/)[0]
    let link = document.createElement('a')

    link.href = url
    link.download = filename
    link.style.display = 'none'

    document.body.append(link)

    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  },
  randomString(len = 8) {
    let str = 'abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ0123456789'
    let res = ''
    for (let i = 0; i < len; i++) {
      let key = Math.floor(Math.random() * str.length)
      res += str[key]
    }
    return res
  },

  debounce(cb, delay = 1000) {
    let timeout
  
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  },

  getContrastRatio(hexColor1, hexColor2) {
    const luminance1 = getLuminance(hexColor1)
    const luminance2 = getLuminance(hexColor2)

    const lighter = Math.max(luminance1, luminance2)
    const darker = Math.min(luminance1, luminance2)

    const contrastRatio = (lighter + 0.05) / (darker + 0.05)

    return parseFloat(contrastRatio.toFixed(2))

    function getLuminance(hexColor) {
      hexColor = hexColor.replace('#', '')
      const r = parseInt(hexColor.substring(0, 2), 16) / 255
      const g = parseInt(hexColor.substring(2, 4), 16) / 255
      const b = parseInt(hexColor.substring(4, 6), 16) / 255

      const luminance = 0.2126 * (r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4)) +
        0.7152 * (g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4)) +
        0.0722 * (b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4))

      return luminance
    }
  },

  getTextColorByBgColor(hexColor) {
    const withWhite = this.getContrastRatio(hexColor, '#ffffff')
    const withBlack = this.getContrastRatio(hexColor, '#000000')
    const textColor = withWhite >= withBlack ? '#ffffff' : '#000000'

    return textColor
  },

  testLog(...args) {
    console.log(...args)
  },
}

export default utils;
